import api from "./baseApi.js";

export default {
  
  async GetCompanyData(companyCode) {

    let searchParams= {
      Code: companyCode
    }

    let res = await api.post("Partners/SearchPartnersByNameAltkn", searchParams);
    res.data = res.data.filter(x=>x.CompanyCode == process.env.VUE_APP_DEFAULT_COMPANY_CODE)[0];
    return res;
  }
}